import { Map as map } from 'immutable';
const C = require("../constants");

function ModalRecipesProductsPreMakeReducer(state = map(), action) {
    switch (action.type) {
        case C.OPEN_MODAL_RECIPES_PRODUCTS_PRE_MAKE:
            return action.modal;
        default:
            return state;
    }
}

export default ModalRecipesProductsPreMakeReducer;


// WEBPACK FOOTER //
// ./src/reducers/ModalRecipesProductsPreMakeReducer.js